module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAS0lEQVQ4y2NgGBxApfY/WZiQAbX9e8F44AxwT1xIvhdANt999A6/K5ANQAYgPkjz3mN3wRjExqaGoAuQXUFWGBAMh8EfjcSnxCENAOUUJaYmxHXXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_nato.png
// module id = 1317
// module chunks = 0